import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { BasicButton } from '../../../component/button';
import { colors } from '../../../component/colors';
import { pxToRem } from '../../../utils/pxToRem';
import { StatusContainer } from '../users/style';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
export const DetailsContainer = styled.div`
  padding: 23px 16px 0px 16px;
`;

export const Card = styled.article`
  background: #ffffff;
  border-radius: 8px 8px 0px 0px;
  margin: 0px 10px;
  margin-bottom: 22px;

  @media (max-width: 500px) {
    margin: 0;
    margin-bottom: 48px;
  }
`;

export const CoverImage = styled.img`
  min-height: 256px;
  max-height: 256px;
  width: 100%;
  min-width: 100%;
  object-fit: cover;
  border-radius: 16px;
  background-color: ${colors.greyText};
  border-radius: 8px 8px 0px 0px;
`;
export const DetailContainer = styled.div`
  display: flex;
  @media (max-width: 600px) {
    flex-wrap: wrap;
  }
`;
export const Avatar = styled.img`
  height: 104px;
  width: 104px;
  border-radius: 100px;
  object-fit: cover;
  background-color: ${colors.greyText};
  margin-top: -50px;
  margin-left: 24px;
  margin-right: 16px;
`;
export const Column = styled.div`
  flex: 1;
  @media (max-width: 600px) {
    order: 2;
    margin-left: 24px;
  }
`;
export const Row = styled.div`
  display: flex;
  margin-top: 4px;
`;
export const AgentName = styled.p`
  font-size: ${pxToRem(21)};
  white-space: nowrap;
  font-weight: 500;
  line-height: ${pxToRem(29)};
  letter-spacing: ${pxToRem(0.15)};
  text-align: left;
  margin-bottom: 4px;
  margin-top: 16px;
`;
export const AgentDetail = styled.p`
  font-size: ${pxToRem(14)};
  font-weight: 500;
  line-height: ${pxToRem(20)};
  text-align: left;
  color: #a1a1a1;
  margin-left: 10px;
  white-space: nowrap;
`;

export const CustomStatusContainer = styled(StatusContainer)`
  margin: 24px;
  padding: 4px 8px;
  align-self: flex-start;
`;

export const Occupation = styled.p`
  width: 55px;
  height: 20px;
  background: #82b1f6;
  border-radius: 50px;
  color: #ffffff;
  font-weight: 400;
  font-size: ${pxToRem(10)};
  line-height: ${pxToRem(12)};
  letter-spacing: 1.5px;
  justify-content: center;
  display: flex;
  text-align: center;
  align-items: center;
  text-transform: capitalize;
  margin-bottom: 24px;
  margin-top: 12px;
`;

export const LinksContainer = styled.div`
  display: flex;
  & :nth-child(2) {
    margin: 0px 17px;
  }
`;

export const CustomLink = styled(Link)<{ active: string }>`
  font-weight: 500;
  letter-spacing: ${pxToRem(0.15)};
  font-size: ${pxToRem(12)};
  line-height: ${pxToRem(16)};
  padding-bottom: 8px;
  text-decoration: none;
  ${({ active }) =>
    active === 'true'
      ? css`
          color: #32324b;
          border-bottom: 2px solid ${colors.sojiOrange};
        `
      : css`
          color: #a1a1a1;
        `}
`;

export const DetailCard = styled.article`
  display: flex;
  flex-direction: column;
  padding: 20px 24px;
  background: #ffffff;
  border-radius: 8px;
`;

export const DetailTitle = styled.h1`
  font-weight: 500;
  font-size: ${pxToRem(16)};
  line-height: ${pxToRem(22)};
  color: #32324b;
  text-transform: capitalize;
`;

export const DetailName = styled(DetailTitle)`
  font-size: ${pxToRem(14)};
  line-height: ${pxToRem(20)};
  padding-bottom: 8px;
`;
export const DetailValue = styled(DetailName)`
  line-height: ${pxToRem(22.4)};
  padding-bottom: unset;
  color: #a1a1a1;
  font-weight: 400;
  span {
    color: red;
  }
`;
export const DetailRow = styled.div`
  display: flex;
  margin: 40px 30px;

  justify-content: space-between;
`;
export const DetailColumn = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

export const VerificationDocumation = styled.img`
  margin-top: 32px;
  width: 280px;
  height: 280px;
  background: ${colors.bgGrey};
  border-radius: 8px;
  object-fit: cover;
`;
export const ButtonContainer = styled.div`
  display: flex;
  margin-bottom: 32px;
`;
export const PrimaryButton = styled(BasicButton)`
  width: 76px;
  height: 40px;
  padding: 0;
  margin-left: 16px;
`;
export const WhiteButton = styled(PrimaryButton)`
  border: 1px solid red;
  background-color: transparent;
  color: red;
`;
